import { HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { BrandsModel, BrandsServerModel } from '@domain/entities/brands.model';

export abstract class BrandsGateway {
    abstract read(params?: HttpParams): Observable<BrandsServerModel[]>;
    abstract create(form: BrandsModel): Observable<BrandsServerModel>;
    abstract readById(id: number): Observable<BrandsServerModel>;
    abstract update(
        id: number,
        form: BrandsModel
    ): Observable<BrandsServerModel>;
    abstract delete(id: number): Observable<BrandsServerModel>;
}
